module.exports = __webpack_public_path__ + "img/tuboDrenoAcessorio2.395bfaeb.png";